import { STATES } from 'common/domain/states';
import { COOKIES } from 'solidarity.module/common/domain/constants';
import { MODALS } from 'common/domain/constants';
import { SOLIDARITY_STATES } from 'solidarity.module/common/domain/constants';
import ongDataAssembler from 'solidarity.module/common/services/ong.assembler';
import { ONG_CARD_STATES } from 'solidarity.module/common/domain/constants.solidarity';

class MySolidarityController {

  constructor(cookieService, solidarityDataService, solidarityService, $q, $log, $state) {
    'ngInject';
    this.cookieService = cookieService;
    this.solidarityDataService = solidarityDataService;
    this.solidarityService = solidarityService;
    this.q = $q;
    this.log = $log;
    this.state = $state;

    this.isLoaded = false;
    this.employeeId = this.solidarityService.employee;
    this.ongList = [];
    this.moreInfo = false;
    this.ongSelected = {};
  }

  $onInit() {
    this._setModalState(SOLIDARITY_STATES.INITIAL);
    this._initData();
  }

  _initData() {
    this.q.all([
      this.solidarityDataService.getOngList(),
      this.solidarityDataService.getContributions(this.employeeId),
    ]).then(responses => {
      const ongData = {
        ongList: responses[0].data,
        contributions: responses[1].data,
      };

      this.log.info('mySolidarity initData', ongData);
      this.ongList = ongDataAssembler.assemble(ongData);
      this.log.info('mySolidarity onList', this.ongList);
      this.isLoaded = true;
    }).catch(error => {
      this.log.error(error);
      // TODO: [Manu] revisar esto, no debería hacer falta con errorInterceptor, no falla como en APP Ayuda Alimentaria pq en el routing de loans se hace esta misma llamada pero sin el state.go error
      this.state.go(STATES.ERROR);
    });
  }

  setShowMoreInfo($event) {
    this.moreInfo = $event.state;
  }

  showMoreInfo() {
    return this.moreInfo === true;
  }

  userHasSeenWhatIsSolidaryEuro() {
    const cookie = `${COOKIES.WHAT_IS_SOLIDARY_EURO}${this.employeeId}`;
    return this.cookieService.get(cookie);
  }

  showWhatIsSolidaryEuro() {
    return !this.showMoreInfo() && !this.userHasSeenWhatIsSolidaryEuro();
  }

  showTitle() {
    return this.showWhatIsSolidaryEuro() || this.showMoreInfo();
  }

  get modal() {
    const $modal = $(MODALS.SOLIDARITY_REQUEST_MODAL);
    $modal.on('hidden.bs.modal', () => {
      this.modalState = SOLIDARITY_STATES.INITIAL;
    });
    return $(MODALS.SOLIDARITY_REQUEST_MODAL);
  }

  _setModalState(state) {
    this.modalState = state;
  }

  _openModal () {
    this.modal.modal('show');
  }

  openModalCancel($event) {
    this.ongSelected = this._getOngFromList($event.ong);
    this._setModalState(SOLIDARITY_STATES.QUESTION_CANCEL);
    this._openModal();
  }

  openModalAccept($event) {
    this.ongSelected = this._getOngFromList($event.ong);
    this.amount = $event.amount;
    this._setModalState(SOLIDARITY_STATES.QUESTION_ACCEPT);
    this._openModal();
  }

  createContribution($event) {
    this.ongSelected = this._getOngFromList($event.ong);
    this.amount = $event.amount;
    let data = this._formatContribution($event.ong, $event.amount);

    this.solidarityDataService.createContribution(this.employeeId, data)
      .then(() => {
       
        this._setModalState(SOLIDARITY_STATES.SUCCESS);
        this._openModal();
        this._initData();
      })
      .catch((response) => {
        this.errorMessage = response.data.message;
        this._setModalState(SOLIDARITY_STATES.FAILED);
        this._openModal();
      });
  }

  updateContribution($event) {
    this.ongSelected = this._getOngFromList($event.ong);
    this.amount = $event.amount;
    let data = this._formatContribution($event.ong, $event.amount);

    this.solidarityDataService.updateContribution(this.employeeId, data)
      .then(() => {
        this._setModalState(SOLIDARITY_STATES.SUCCESS);
        this._openModal();
        this._initData();
      })
      .catch((response) => {
        this.errorMessage = response.data.message;
        this._setModalState(SOLIDARITY_STATES.FAILED);
        this._openModal();
      });
  }

  cancelContribution($event) {
    let data = this._formatContribution($event.ong);

    this.solidarityDataService.deleteContribution(this.employeeId, data)
      .then(() => {
        this._setModalState(SOLIDARITY_STATES.DELETED);
        this._initData();
      })
      .catch((response) => {
        this.errorMessage = response.data.message;
        this._setModalState(SOLIDARITY_STATES.FAILED);
      });
  }

  _formatContribution(ong, amount) {
    let formattedData = [];
    const entity = ong.code;
    const startDate = ong.contribution.startDate;
    amount = amount || ong.contribution.amount;
    const ongFormatted = { entity, startDate, amount };
    formattedData.push(ongFormatted);
    return formattedData;
  }

  _getOngFromList(ongSelected) {
    let ong = this.ongList.filter((ong) => {
      return ong.code === ongSelected.code;
    });
    return ong[0];
  }

  _setCardState(state) {
    this.ongSelected.setState(state);
  }

  _setCardStateContribution() {
    this._setCardState(ONG_CARD_STATES.CONTRIBUTION);
  }

  _setCardStateInitial() {
    this._setCardState(ONG_CARD_STATES.INITIAL);
  }

}

export default MySolidarityController;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/mySolidarity.controller.js